import { render, staticRenderFns } from "./leftTop.vue?vue&type=template&id=6a845ffe&scoped=true&"
import script from "./leftTop.vue?vue&type=script&lang=js&"
export * from "./leftTop.vue?vue&type=script&lang=js&"
import style0 from "./leftTop.vue?vue&type=style&index=0&id=6a845ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a845ffe",
  null
  
)

export default component.exports